/**
 * Reads every JSON file in a content folder at build time.
 *
 * The content lives in src/content and is edited through the CMS at /admin,
 * which commits each change to the repo; the next deploy picks it up. One file
 * per entry is what lets the CMS create and delete entries, so the folders are
 * read whole rather than through a fixed list of imports.
 */

interface ContentContext {
    keys(): string[];
    (id: string): unknown;
}

declare global {
    interface NodeRequire {
        context(dir: string, deep?: boolean, filter?: RegExp): ContentContext;
    }
}

/** `{ slug, data }` for each file; slug is the file name without `.json`. */
export function readFolder<T>(ctx: ContentContext): { slug: string; data: T }[] {
    return ctx.keys().map((key) => ({
        slug: key.replace(/^\.\//, "").replace(/\.json$/, ""),
        data: ctx(key) as T,
    }));
}
